import { apiMethods } from '~/services/api';
import { IConversationResponse } from '~/models/Conversation';
import { IMessage } from '~/models/Message';

export interface IGetConversationsParams {
  page: number;
  limit: number;
  status?: 'unread';
}

async function getConversations(params: IGetConversationsParams): Promise<IConversationResponse> {
  return apiMethods.getMessagesRequest(params);
}

async function getJobMessages(jobId: string): Promise<IMessage[]> {
  return apiMethods.getMessagesByJobIdRequest(jobId);
}

async function postMessage(payload: { jobId: string; message: string }): Promise<IMessage> {
  return apiMethods.postMessageRequest(payload);
}

export const messagesService = {
  getConversations,
  getJobMessages,
  postMessage,
};
